import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class TokenService {
    readonly token_key: string;
    readonly expiration_time_key: string;

    private _token: string | null;
    private _expirationTime: string | null;
    private window: Window;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private environmentService: EnvironmentService
    ) {
        this.window = this.document.defaultView;
        this.token_key = 'token-' + this.environmentService.getEnvironment();
        this.expiration_time_key =
            'expiration-time-' + this.environmentService.getEnvironment();
        this._token = this.window.localStorage.getItem(this.token_key);
        this._expirationTime = this.window.localStorage.getItem(
            this.expiration_time_key
        );
    }

    clear() {
        // Limpar localStorage de forma específica (mais seguro que localStorage.clear())
        this.window.localStorage.removeItem(this.token_key);
        this.window.localStorage.removeItem(this.expiration_time_key);

        // Limpar propriedades internas
        this._token = null;
        this._expirationTime = null;
    }

    get token() {
        return this._token;
    }

    get expirationTime() {
        return this._expirationTime ? parseInt(this._expirationTime) : null;
    }

    get() {
        return {
            token: this.token,
            expiration_time: this.expirationTime,
        };
    }

    store(token: string, expiration_time: number) {
        this._expirationTime = expiration_time.toString();
        this._token = token;

        this.window.localStorage.setItem(this.token_key, this._token);
        this.window.localStorage.setItem(
            this.expiration_time_key,
            this._expirationTime
        );
    }
}
